<template>
  <div class="student-evolution navigation-top-app">
    <navigation-top-app
      v-if="evaluation.show === false"
      :app="app"
      :menu-screen="app.user.role === 'student'"
      :back="() => {
        $router.push({name: 'app.student.profile', params: {code: this.student.data.code}, query: {origin: 'app', navigationLeft: 'false', token: app.token}})
      }"
    >
      <template v-slot:center>
        <div id="navigation-center">
          {{ app.strings.app.student.evolution.title }}
        </div>
      </template>
    </navigation-top-app>
    <navigation-top-app
      v-if="evaluation.show === true"
      :app="app"
      :menu-screen="app.user.role === 'student' && evaluation.data.length <= 1"
      :back="closeEvaluation"
    >
      <template v-slot:center>
        <div id="navigation-center">
          {{ app.strings.app.student.evolution.short }} · {{ evaluation.selected.name | truncate(24) }}
        </div>
      </template>
    </navigation-top-app>
    <transition name="fade">
      <div id="student-evolution-content" class="max-width-800 margin-auto" v-if="show && !loading">
        <template v-if="evaluation.show === false">
          <list :app="app" :items="evaluation.data" :index="'id'" :value="'name'" @onSelect="(evaluation) => {
            openEvaluation(evaluation)
          }" />
          <div class="evolution-empty" v-if="evaluation.data.length === 0">
            <font-awesome-icon :icon="['fas', 'chart-pie']" />
            <span>{{ app.strings.app.student.evolution.empty }}</span>
          </div>
        </template>
        <template v-else>
          <div class="evolution-head" v-if="mean !== ''">
            <div class="evolution-mean" :class="'evaluation-' + meanLevel">{{ mean }}<small>%</small></div>
            <div class="evolution-head-data">
              <div class="evolution-name" v-if="app.user.role === 'teacher' && student.name">{{ student.name }}</div>
              <div class="evolution-overall">{{ app.strings.app.student.evolution.overall }}</div>
              <div class="evolution-legend">{{ app.strings.app.student.evolution.legend }}</div>
            </div>
          </div>
          <div class="evolution-empty" v-else>
            <font-awesome-icon :icon="['fas', 'chart-pie']" />
            <span>{{ app.strings.app.student.evolution.empty }}</span>
          </div>
          <student-evaluation-practice-component :show-mean="false" v-on:onMean="(value, level) => { mean = value; meanLevel = level }" :app="app" :student="student.data.code" :evaluation="evaluation.selected" :editable="false" />
        </template>
      </div>
    </transition>
    <transition name="fade">
      <div id="student-evolution-content" class="max-width-800 margin-auto" v-if="show && loading">
        <loader-dot :size="'16px'" :color_1="'rgb(32, 113, 183)'" :color_2="'rgb(32, 113, 183)'" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app-student-evolution-view',
  data () {
    return {
      show: false,
      mean: '',
      meanLevel: '',
      student: {
        name: '',
        loading: false,
        data: {
          id: 0
        }
      },
      evaluation: {
        loading: false,
        show: false,
        data: [],
        student: {
          data: []
        },
        selected: {}
      }
    }
  },
  props: [
    'app'
  ],
  computed: {
    loading () {
      if (this.evaluation.loading) {
        return true
      }

      return false
    }
  },
  mounted () {
    this.student.data.code = this.$route.params.code

    this.show = true

    this.practiceEvaluationReadAll()
    this.studentNameRead()
  },
  methods: {
    // Only for the heading: without it the screen still works.
    studentNameRead () {
      this.$http.get(
        this.app.url.api + this.app.endpoints.student.read.one + this.student.data.code,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200 && response.body.success === true) {
          let student = response.body.data.student
          this.student.name = [student.first_name, student.last_name_1, student.last_name_2].filter(Boolean).join(' ')
        }
      }, () => {})
    },
    // With a single template the list has nothing to offer: go to the profile.
    closeEvaluation () {
      if (this.evaluation.data.length > 1) {
        this.evaluation.show = false
      } else {
        this.$router.push({name: 'app.student.profile', params: {code: this.student.data.code}, query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
      }
    },
    practiceEvaluationReadAll () {
      if (this.evaluation.loading) {
        return
      }

      this.evaluation.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.practice.evaluation.read.all + '?student=' + this.student.data.code,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.evaluation.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            this.evaluation.data = response.body.data.evaluations
            this.evaluation.student.data = response.body.data.student

            this.updateEvaluationValues()

            // With a single template there is nothing to choose: open it.
            if (this.evaluation.data.length === 1) {
              this.openEvaluation(this.evaluation.data[0])
            }
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-evaluation-read-all', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.evaluation.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    updateEvaluationValues () {
      for (let i in this.evaluation.data) {
        let evaluation = this.evaluation.data[i]
        for (let j in evaluation.groups) {
          let group = evaluation.groups[j]
          for (let u in group.items) {
            let item = group.items[u]
            group.items[u].value = 1
            for (let i in this.evaluation.student.data) {
              let evaluation = this.evaluation.student.data[i]
              if (evaluation.item === item.id && evaluation.business_id === item.business_id) {
                group.items[u].value = evaluation.value
              }
            }
          }
        }
      }
    },
    openEvaluation (evaluation) {
      this.evaluation.selected = evaluation
      this.evaluation.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

#student-evolution-content {
  position: relative;
  width: 100%;
  min-height: 100%;
  padding: 72px 0 24px;
  box-sizing: border-box;
}

.evolution-head {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px;
  border: 1px solid #e8edf3;
  border-radius: 20px;
  background-color: #FFFFFF;
  box-shadow: 0 12px 30px rgba(20, 67, 107, 0.08);
}

.evolution-mean {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border: 6px solid #dbe8f5;
  border-radius: 999px;
  box-sizing: border-box;
  color: #64748b;
  font-family: 'Lexend', sans-serif;
  font-size: 22px;
  font-weight: 700;
}

.evolution-mean > small {
  margin-left: 1px;
  font-size: 12px;
}

.evolution-mean.evaluation-50 { border-color: rgba(32, 113, 183, 0.45); color: #2071b7; }
.evolution-mean.evaluation-75 { border-color: rgba(15, 118, 110, 0.45); color: #0f766e; }
.evolution-mean.evaluation-100 { border-color: rgba(21, 128, 61, 0.55); color: #15803d; }

.evolution-head-data {
  min-width: 0;
}

.evolution-name {
  color: #1f2a37;
  font-family: 'Lexend', sans-serif;
  font-size: 17px;
  font-weight: 700;
  overflow-wrap: break-word;
}

.evolution-overall {
  color: #1f2a37;
  font-size: 14px;
  font-weight: 600;
}

.evolution-legend {
  margin-top: 2px;
  color: #64748b;
  font-size: 13px;
}

.evolution-empty {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border-radius: 16px;
  background-color: #FFFFFF;
  color: #64748b;
  font-size: 14px;
}

.evolution-empty > svg {
  flex: 0 0 auto;
  color: #94a3b8;
  font-size: 20px;
}

// The screen scrolls as a whole: a scroller here cut the shadows of the cards.
.student-evolution ::v-deep #practice-view-evaluation {
  overflow: visible;
  padding-top: 0;
}

.student-evolution ::v-deep .practice-view-evaluation-group {
  margin-top: 14px;
}

@media (min-width: 768px) {
  .student-evolution ::v-deep #practice-view-evaluation {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    align-items: stretch;
    margin-top: 14px;
  }

  .student-evolution ::v-deep .practice-view-evaluation-group {
    margin-top: 0;
  }

  // An odd last card takes the whole row instead of leaving a hole.
  .student-evolution ::v-deep .practice-view-evaluation-group:last-child:nth-child(odd) {
    grid-column: 1 / -1;
  }
}

@media (min-width: 1024px) {
  #student-evolution-content {
    padding-top: 92px;
  }
}

</style>
